import React from 'react';
import { motion } from 'framer-motion';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <div className="min-h-screen bg-gradient-to-br from-beige-50 to-sage-50 flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-md w-full bg-white rounded-2xl shadow-soft-lg p-8 text-center"
          >
            <div className="text-6xl mb-4">😕</div>
            <h2 className="text-2xl font-playfair font-bold text-charcoal-900 mb-3">
              Oops! Something went wrong
            </h2>
            <p className="text-charcoal-600 mb-6">
              We're sorry, but something unexpected happened. Don't worry, your data is safe!
            </p>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="mb-6 text-left bg-red-50 p-4 rounded-lg">
                <summary className="text-sm font-semibold text-red-800 cursor-pointer mb-2">
                  Error Details (Dev Only)
                </summary>
                <pre className="text-xs text-red-700 overflow-auto">
                  {this.state.error.toString()}
                </pre>
              </details>
            )}

            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => window.location.reload()}
                className="flex-1 bg-gradient-to-r from-sage-500 to-teal-500 text-white px-6 py-3 rounded-xl font-semibold hover:from-sage-600 hover:to-teal-600 transition-all shadow-md"
              >
                Refresh Page
              </button>
              <button
                onClick={() => window.location.href = '/dashboard'}
                className="flex-1 bg-white text-charcoal-700 px-6 py-3 rounded-xl font-semibold hover:bg-beige-50 transition-all border-2 border-sage-200"
              >
                Go to Dashboard
              </button>
            </div>
          </motion.div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
